import axios from 'axios';
import HeaderToken from '../constants/header-token';

// use the env var if it's available, and trim any tailing / to prevent double // in baseURL
const apiCoreHost = (process.env.POINT_OF_CARE_API_URL || '').trimRight();

const requestHandler = (req: any) => {
    const identityToken = sessionStorage.getItem(
        HeaderToken.CORE_API_ACCESS_TOKEN_NAME
    );
    if (!req.headers.authorization && identityToken) {
        req.headers.authorization = `Bearer ${identityToken}`;
    }
    return req;
};

const coreApiInstance = axios.create({
    headers: { Accept: 'application/json' },
    baseURL: `${apiCoreHost}/api/`,
});

coreApiInstance.interceptors.request.use((request) => requestHandler(request));

export default coreApiInstance;
